import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class AppRouterLinkComponent extends Vue {
  private clickCallback: any;

  @Prop({ default: false })
  public disabled!: boolean;

  @Prop()
  public tabindex!: string;

  @Prop()
  public to!: string;

  @Prop()
  public replace!: boolean;

  @Prop()
  public append!: boolean;

  @Prop()
  public tag!: string;

  @Prop({ default: 'router-link-active' })
  public activeClass!: string;

  @Prop()
  public exact!: boolean;

  @Prop({ default: 'click' })
  public event!: string | string[];

  @Prop({ default: 'router-link-exact-active' })
  public exactActiveClass!: string;

  @Prop({ default: 'page' })
  public ariaCurrentValue!: 'page' | 'step' | 'location' | 'date' | 'time';

  get resolvedTabindex(): string {
    return this.disabled ? '-1' : this.tabindex;
  }

  private mounted() {
    this.clickCallback = this.onClick.bind(this);
    this.$el.addEventListener('click', this.clickCallback);
  }

  private beforeDestroy() {
    this.$el.removeEventListener('click', this.clickCallback);
  }

  private onClick(e: Event) {
    this.$emit('click', e);
  }
}
